import { ActionType, createAsyncAction } from 'typesafe-actions'
import { MessageState } from '../../types'
import { Failure, Request, Success } from './types'

export const fetchQuickReplyMessagesAction = createAsyncAction(
  '@message/FETCH_QUICK_REPLY_MESSAGES_REQUEST',
  '@message/FETCH_QUICK_REPLY_MESSAGES_SUCCESS',
  '@message/FETCH_QUICK_REPLY_MESSAGES_FAILURE'
)<Request, Success, Failure>()

const request = (state: MessageState): MessageState => ({
  ...state,
  isLoadingOnFetchQuickReplyMessages: true
})

const success = (
  state: MessageState,
  action: ActionType<typeof fetchQuickReplyMessagesAction.success>
): MessageState => {
  return {
    ...state,
    quickReplies: action.payload.quickReplies,
    isSuccessOnFetchQuickReplyMessages: true,
    isLoadingOnFetchQuickReplyMessages: false
  }
}

const failure = (state: MessageState): MessageState => {
  return {
    ...state,
    isLoadingOnFetchQuickReplyMessages: false,
    isErrorOnFetchQuickReplyMessages: true
  }
}

export const fetchQuickReplyMessagesHandle = {
  asyncAction: fetchQuickReplyMessagesAction,
  request,
  success,
  failure
}
